export default store => {
  store.subscribe(mutation => {
    if (mutation.type === 'usCredit/SET_CREDIT_SCORE') {
      // Set the us credit score to the original credit module
      store.commit('credit/SET_CREDIT_GRADE', mutation.payload);
    }

    if (mutation.type === 'usCredit/SET_BUREAU_CODE') {
      // Set the us bureauCode to the original credit module
      store.commit('credit/SET_BUREAU_CODE', mutation.payload);
    }
  });
};
